import { useEmailCampaignConfirmation } from './useEmailCampaignConfirmation'
import { useLogoutHandler } from './useLogoutHandler'
import { ISessionContext } from '../session'

export function useCommonLogic(sessionContext: ISessionContext) {
  useEmailCampaignConfirmation(sessionContext)
  useLogoutHandler(sessionContext)
}
